import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Service {
  id: string;
  stripe_product_id: string | null;
  stripe_price_id: string | null;
  name: string;
  description: string | null;
  base_price: number;
  currency_code: string;
  category: string | null;
  is_active: boolean;
  is_archived: boolean;
  display_order: number;
  metadata: any;
  version: number;
  created_at: string;
  updated_at: string;
}

export const useServicesCatalog = () => {
  return useQuery({
    queryKey: ['services-catalog'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('services')
        .select('*')
        .eq('is_active', true)
        .eq('is_archived', false)
        .order('display_order', { ascending: true });

      if (error) {
        console.error('Error fetching services:', error);
        throw error;
      }

      return data as Service[];
    },
  });
};